export const findOriginal = <T extends { id: number }>(
	items: T[] | undefined,
	id: number | null,
) => (id === null ? undefined : items?.find((item) => item.id === id));
